export default function FinalCTA() {
  return (
    <section id="cta" className="relative py-[160px] overflow-hidden bg-white dark:bg-[#060A14]">
      <div className="absolute inset-0 bg-gradient-radial from-[#6366F1]/10 dark:from-[#6366F1]/20 via-transparent to-transparent"></div>
      <div className="relative max-w-[1280px] mx-auto px-6 text-center">
        <h2 className="text-[64px] font-extrabold text-gray-900 dark:text-white leading-tight tracking-tight mb-6">
          Your next job starts here.
        </h2>
        <p className="text-gray-500 dark:text-[#94A3B8] text-xl max-w-[640px] mx-auto mb-12">
          Stop managing your job search in spreadsheets.<br />Start using the OS built for it.
        </p>
        <div className="flex items-center justify-center gap-4 mb-8 flex-wrap">
          <a href="https://app.jobos.dev" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 h-16 px-12 bg-[#6366F1] text-white text-xl font-bold rounded-full transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_16px_48px_rgba(99,102,241,0.5)] cursor-pointer whitespace-nowrap">
            <span>Get Started Free</span>
            <i className="ri-arrow-right-line text-2xl"></i>
          </a>
          <a href="https://chrome.google.com/webstore" className="inline-flex items-center gap-3 h-16 px-12 border-2 border-[#6366F1] text-[#6366F1] text-xl font-bold rounded-full transition-all duration-200 hover:bg-[#6366F1]/10 cursor-pointer whitespace-nowrap">
            <i className="ri-chrome-line text-2xl"></i>
            <span>Add to Chrome — Free</span>
          </a>
        </div>
        <div className="flex items-center justify-center gap-3 flex-wrap">
          <span className="text-gray-500 dark:text-[#94A3B8] text-base">Free plan available</span>
          <span className="text-gray-300 dark:text-[#475569]">•</span>
          <span className="text-gray-500 dark:text-[#94A3B8] text-base">No credit card</span>
          <span className="text-gray-300 dark:text-[#475569]">•</span>
          <span className="text-gray-500 dark:text-[#94A3B8] text-base">Works globally</span>
        </div>
      </div>
    </section>
  );
}
